// Import model
import { FilterProjectRequest } from '../models/FilterProjectRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProjectCondition } from '../models/ProjectCondition';
import { ProjectFields } from '../models/ProjectFields';
import { ProjectIndexedFields } from '../models/ProjectIndexedFields';

// Import dependency serializers (for complex types)
import { ProjectConditionSerializer } from './ProjectConditionSerializer';
import { ProjectFieldsSerializer } from './ProjectFieldsSerializer';
import { ProjectIndexedFieldsSerializer } from './ProjectIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProjectRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProjectRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProjectRequest instance
   */
  static deserialize(json: string): FilterProjectRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProjectRequest instance
   */
  static fromObject(obj: any): FilterProjectRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProjectRequest');
    }


    const instance: FilterProjectRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProjectIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProjectFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProjectConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProjectRequest instances
   */
  static deserializeArray(json: string): FilterProjectRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProjectRequest instance to a JSON string
   */
  static serialize(instance: FilterProjectRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProjectRequest instance to a plain object
   */
  static toObject(instance: FilterProjectRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProjectConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProjectRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProjectRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
